import React, { useEffect, useMemo, useState } from 'react';
import { PortalShell } from '@/components/nav/PortalShell';
import { portalApi } from '@/lib/api';
import { Card, CardContent } from '@/components/ui/card';
import { JobStatusPill } from '@/components/jobs/JobStatusPill';
import { fmtDate } from '@/lib/format';
import { EmptyState } from '@/components/empty/EmptyState';
import { ListSkeleton } from '@/components/common/ListSkeleton';
import { Calendar } from 'lucide-react';

export default function PortalSchedulePage() {
  const [jobs, setJobs] = useState([]);
  const [loaded, setLoaded] = useState(false);
  useEffect(() => {
    portalApi.jobs()
      .then(setJobs)
      .catch(() => {}) // surfaced by the api response interceptor
      .finally(() => setLoaded(true));
  }, []);
  const grouped = useMemo(() => {
    const map = {};
    jobs.forEach(j => {
      const key = j.scheduled_at ? new Date(j.scheduled_at).toDateString() : 'Unscheduled';
      (map[key] = map[key] || []).push(j);
    });
    return map;
  }, [jobs]);

  return (
    <PortalShell title="Schedule">
      <h1 className="font-display text-2xl md:text-3xl font-semibold mb-1">Schedule</h1>
      <p className="text-sm text-muted-foreground mb-4">Your upcoming and past cleanings.</p>
      {!loaded ? (
        <ListSkeleton />
      ) : jobs.length === 0 ? (
        <EmptyState icon={Calendar} title="No cleanings yet" description="When we schedule your first cleaning it will appear here." />
      ) : (
        <div className="space-y-4">
          {Object.entries(grouped).map(([day, list]) => (
            <div key={day}>
              <div className="text-xs uppercase tracking-wide text-muted-foreground mb-1">{day}</div>
              <Card><CardContent className="p-0"><div className="divide-y">
                {list.map(j => (
                  <div key={j.id} className="flex flex-col gap-2 sm:flex-row sm:items-center sm:justify-between px-4 py-3 transition-colors hover:bg-muted/40">
                    <div>
                      <div className="font-medium text-sm">{j.property_nickname || 'Cleaning'}</div>
                      <div className="text-xs text-muted-foreground">{fmtDate(j.scheduled_at)} • {j.duration_hours || 3}h</div>
                    </div>
                    <JobStatusPill status={j.status} />
                  </div>
                ))}
              </div></CardContent></Card>
            </div>
          ))}
        </div>
      )}
    </PortalShell>
  );
}
